/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlayListDto } from '../../models/play-list-dto';

export interface PlaylistControllerFindAllByClientId$Params {
  clientWorkspaceId: string;
}

export function playlistControllerFindAllByClientId(http: HttpClient, rootUrl: string, params: PlaylistControllerFindAllByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlayListDto>>> {
  const rb = new RequestBuilder(rootUrl, playlistControllerFindAllByClientId.PATH, 'get');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PlayListDto>>;
    })
  );
}

playlistControllerFindAllByClientId.PATH = '/api/playlist/all/{clientWorkspaceId}';
